// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__1etdb","radio":"style_radio__ddRGD","radio_disk":"style_radio_disk__kx4ic","text":"style_text__yzhax"};